import { useQuery } from "@tanstack/react-query";
import {
  SIDEBAR_COUNT_LIVE_PRODUCTS,
  SIDEBAR_COUNT_IMPORTED_PRODUCTS,
  SIDEBAR_COUNT_SAMPLE_ORDERS,
  SIDEBAR_COUNT_SHOPIFY_ORDERS,
  ISidebarCount,
} from "./types";
import {
  getSidebarCountLiveProducts,
  getSidebarCountImportedProducts,
  getSidebarCountSampleOrders,
  getSidebarCountShopifyOrders,
} from "./requests";

// Sidebar counts are non-critical UI decoration — cache for 2 min to avoid
// competing with above-the-fold product queries on initial page load.
const SIDEBAR_STALE_TIME = 2 * 60 * 1000;

export const useGetSidebarCountLiveProducts = () =>
  useQuery<ISidebarCount>(
    SIDEBAR_COUNT_LIVE_PRODUCTS,
    () => getSidebarCountLiveProducts(),
    {
      staleTime: SIDEBAR_STALE_TIME,
    }
  );

export const useGetSidebarCountImportedProducts = () =>
  useQuery<ISidebarCount>(
    SIDEBAR_COUNT_IMPORTED_PRODUCTS,
    () => getSidebarCountImportedProducts(),
    {
      staleTime: SIDEBAR_STALE_TIME,
    }
  );

export const useGetSidebarCountSampleOrders = () =>
  useQuery<ISidebarCount>(
    SIDEBAR_COUNT_SAMPLE_ORDERS,
    () => getSidebarCountSampleOrders(),
    {
      staleTime: SIDEBAR_STALE_TIME,
    }
  );

export const useGetSidebarCountShopifyOrders = () =>
  useQuery<ISidebarCount>(
    SIDEBAR_COUNT_SHOPIFY_ORDERS,
    () => getSidebarCountShopifyOrders(),
    {
      staleTime: SIDEBAR_STALE_TIME,
    }
  );
